import { render } from "./Htmls.vue?vue&type=template&id=ee8a67dc"
import script from "./Htmls.vue?vue&type=script&lang=js"
export * from "./Htmls.vue?vue&type=script&lang=js"

import exportComponent from "D:\\project\\pc\\website\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__